import React from 'react';
import { Icon } from './MenuIcon.styles';
export function MenuIcon({ isOpen }) {
    return (React.createElement(Icon, { isOpen: isOpen },
        React.createElement("span", null),
        React.createElement("span", null),
        React.createElement("span", null)));
}
//# sourceMappingURL=MenuIcon.js.map